import Transform from "@ember-data/serializer/transform";

export default class RadiotherapiesTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(radiotherapy => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (radiotherapy.startDate) {
        radiotherapy.startDate = new Date(radiotherapy.startDate);
      }
      if (radiotherapy.endDate) {
        radiotherapy.endDate = new Date(radiotherapy.endDate);
      }
      if (radiotherapy.consultation) {
        radiotherapy.consultation = new Date(radiotherapy.consultation);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    radiotherapies: RadiotherapiesTransform;
  }
}
